import {
  GET_REDEEM,
  GET_SETTING,
} from "./types";

const initialState = {
  redeem: [],
  totalRedeem: 0,
  totalRevenue: 0,
  setting: {},
};

const redeemReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REDEEM:
      return {
        ...state,
        redeem: action.payload.data,
        totalRedeem: action.payload.total,
      };
    case GET_SETTING:
      return {
        ...state,
        setting: action.payload,
      };
    default:
      return state;
  }
};

export default redeemReducer;
